"use client";

import { createContext, useContext, type ReactNode } from 'react';
import type { Engine } from '../core/engine';

const QueryResultContext = createContext<{ engine: Engine } | null>(null);

export function QueryResultProvider({
  children,
  engine
}: {
  children: ReactNode;
  engine: Engine;
}) {
  return (
    <QueryResultContext.Provider value={{ engine }}>
      {children}
    </QueryResultContext.Provider>
  );
}

export function useQueryResultContext() {
  const context = useContext(QueryResultContext);
  if (!context) {
    throw new Error('useQueryResultContext must be used within QueryResultProvider');
  }
  return context;
} 